import React from 'react';

const ApiKey = () => <div><h2>API Key</h2></div>;

export default ApiKey;
